import { createAsyncThunk } from "@reduxjs/toolkit";
import driverAPI from "./api";

export const getVehicleCategories = createAsyncThunk(
  "vehicle-categories/getAll/loading",
  async () => {
    return driverAPI.getAllDriverVehicleCategories();
  }
);
